import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=6011210c&scoped=true&"
var script = {}
import style0 from "@/scss/components/loading.css?vue&type=style&index=0&id=6011210c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6011210c",
  null
  
)

export default component.exports